import React from "react";

// Colors: Primary Blue (#0047AB), Cyan (#0891B2), Light Grey (#f3f4f6), Dark Text (#111827)

export const ClinicIllustration = () => (
  <svg viewBox="0 0 400 300" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
    {/* Base Background Plate */}
    <rect x="50" y="80" width="300" height="180" rx="20" fill="#f8fafc" />
    <path d="M50 160 Q 200 120 350 160 L 350 260 L 50 260 Z" fill="#e2e8f0" opacity="0.4" />
    
    {/* Main Clinic Building */}
    <rect x="120" y="90" width="160" height="170" rx="10" fill="#ffffff" />
    <rect x="110" y="80" width="180" height="20" rx="6" fill="#0047AB" />
    
    {/* Clinic Shadow */}
    <rect x="280" y="90" width="10" height="170" fill="#cbd5e1" opacity="0.4" />

    {/* Door */}
    <rect x="175" y="190" width="50" height="70" rx="4" fill="#0891B2" opacity="0.1" />
    <rect x="175" y="190" width="50" height="70" rx="4" fill="none" stroke="#0891B2" strokeWidth="2" />
    
    {/* Windows */}
    <rect x="135" y="120" width="35" height="40" rx="4" fill="#bae6fd" opacity="0.4" />
    <rect x="185" y="120" width="30" height="40" rx="4" fill="#bae6fd" opacity="0.4" />
    <rect x="230" y="120" width="35" height="40" rx="4" fill="#bae6fd" opacity="0.4" />

    {/* Floating Tooth Logo on top */}
    <g transform="translate(180, 20) scale(0.4)">
      <path d="M50 80 Q50 30 20 20 Q50 10 50 -30 Q50 10 80 20 Q50 30 50 80" fill="#0047AB" />
      <path d="M 20 60 C 20 40, 40 40, 40 60 C 40 80, 20 80, 20 60 Z C 20 40, 0 40, 0 60 C 0 80, 20 80, 20 60 Z M 20 60 L 20 90 L 10 100 L 10 110 L 20 105 L 30 110 L 30 100 L 20 90" fill="#0891B2" stroke="#ffffff" strokeWidth="6" transform="translate(25, -5) scale(1.6)" />
    </g>
    
    {/* Abstract UI elements mimicking startup metrics */}
    <rect x="70" y="140" width="60" height="40" rx="8" fill="#ffffff" filter="drop-shadow(0 4px 6px rgba(0,0,0,0.05))" />
    <rect x="80" y="152" width="20" height="4" rx="2" fill="#0047AB" opacity="0.6" />
    <rect x="80" y="162" width="40" height="4" rx="2" fill="#cbd5e1" />

    <rect x="270" y="110" width="70" height="50" rx="8" fill="#ffffff" filter="drop-shadow(0 4px 6px rgba(0,0,0,0.05))" />
    <circle cx="295" cy="135" r="12" fill="#0891B2" opacity="0.2" />
    <circle cx="295" cy="135" r="6" fill="#0891B2" />
    <rect x="315" y="125" width="15" height="4" rx="2" fill="#cbd5e1" />
    <rect x="315" y="135" width="10" height="4" rx="2" fill="#cbd5e1" />
  </svg>
);

export const ToolsIllustration = () => (
  <svg viewBox="0 0 400 300" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
    <rect x="50" y="50" width="300" height="200" rx="24" fill="#f8fafc" />
    <circle cx="200" cy="150" r="80" fill="#f1f5f9" />
    
    {/* Magnifying Glass / Mirror */}
    <path d="M120 220 L 180 160" stroke="#cbd5e1" strokeWidth="12" strokeLinecap="round" />
    <circle cx="200" cy="140" r="40" fill="#ffffff" stroke="#0047AB" strokeWidth="8" />
    <circle cx="190" cy="130" r="10" fill="#bae6fd" opacity="0.6" />
    
    {/* Tooth in mirror */}
    <g transform="translate(170, 115) scale(0.6)">
      <path d="M 50 10 C 20 10, 10 30, 20 50 C 30 70, 40 90, 30 110 C 40 100, 50 90, 50 70 C 50 90, 60 100, 70 110 C 60 90, 70 70, 80 50 C 90 30, 80 10, 50 10 Z" fill="#0891B2" />
    </g>

    {/* Floating UI Toolcards */}
    <rect x="240" y="80" width="90" height="60" rx="10" fill="#ffffff" filter="drop-shadow(0 4px 6px rgba(0,0,0,0.05))" />
    <rect x="255" y="95" width="20" height="20" rx="4" fill="#0047AB" opacity="0.1" />
    <rect x="285" y="100" width="35" height="4" rx="2" fill="#cbd5e1" />
    <rect x="285" y="110" width="20" height="4" rx="2" fill="#cbd5e1" />

    <rect x="70" y="100" width="80" height="50" rx="10" fill="#ffffff" filter="drop-shadow(0 4px 6px rgba(0,0,0,0.05))" />
    <rect x="85" y="115" width="30" height="4" rx="2" fill="#0047AB" />
    <rect x="85" y="125" width="40" height="4" rx="2" fill="#cbd5e1" />

    {/* Dental Tool Probe */}
    <path d="M 280 220 L 240 140" stroke="#0891B2" strokeWidth="6" strokeLinecap="round" opacity="0.4" />
    <circle cx="240" cy="140" r="5" fill="#0891B2" />
  </svg>
);

export const DeliveryIllustration = () => (
  <svg viewBox="0 0 400 300" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
    <rect x="50" y="50" width="300" height="200" rx="24" fill="#f8fafc" />
    
    {/* Road line */}
    <rect x="80" y="210" width="240" height="4" rx="2" fill="#e2e8f0" />
    
    {/* Abstract Phone/Screen holding the delivery status */}
    <rect x="140" y="70" width="120" height="150" rx="16" fill="#ffffff" filter="drop-shadow(0 10px 15px rgba(0,0,0,0.05))" />
    <rect x="155" y="85" width="90" height="80" rx="8" fill="#f1f5f9" />
    <rect x="155" y="180" width="60" height="6" rx="3" fill="#cbd5e1" />
    <rect x="155" y="195" width="40" height="6" rx="3" fill="#cbd5e1" />

    {/* Delivery Box / Location Pin over Phone */}
    <path d="M 200 95 C 185 95, 175 105, 175 120 C 175 140, 200 155, 200 155 C 200 155, 225 140, 225 120 C 225 105, 215 95, 200 95 Z" fill="#0047AB" />
    <circle cx="200" cy="115" r="8" fill="#ffffff" />

    {/* Floating Box / Parcel */}
    <g transform="translate(240, 150)">
      <rect x="0" y="0" width="60" height="50" rx="6" fill="#ffffff" filter="drop-shadow(0 4px 6px rgba(0,0,0,0.08))" />
      <rect x="0" y="0" width="60" height="15" fill="#0891B2" opacity="0.1" />
      <rect x="25" y="0" width="10" height="50" fill="#0891B2" opacity="0.1" />
      <path d="M 23 25 C 23 15, 37 15, 37 25 C 37 35, 30 40, 30 40 C 30 40, 23 35, 23 25 Z" fill="#0891B2" opacity="0.8" />
    </g>

    {/* Speed lines */}
    <rect x="90" y="160" width="30" height="4" rx="2" fill="#0891B2" opacity="0.3" />
    <rect x="110" y="175" width="15" height="4" rx="2" fill="#0891B2" opacity="0.2" />
  </svg>
);
